export default __webpack_public_path__ + "static/media/icona-calavera-casa.c843ff34.svg";